module.exports = __webpack_public_path__ + "static/media/ico_conexao_new.526d2705.svg";